import React, { useEffect, useState } from 'react';
import './BookStore.css';
import { apiGet } from '../api';

const books = [
  { id: 1, name: 'Soil Secrets', rate: '₹299', cover: 'https://picsum.photos/seed/soil/300/420' },
  { id: 2, name: 'Seeds of Life', rate: '₹349', cover: 'https://picsum.photos/seed/seeds/300/420' },
  { id: 3, name: 'Water Wisdom', rate: '₹279', cover: 'https://picsum.photos/seed/water/300/420' },
  { id: 4, name: 'Home Garden', rate: '₹319', cover: 'https://picsum.photos/seed/garden/300/420' },
  { id: 5, name: 'Natural Pests', rate: '₹259', cover: 'https://picsum.photos/seed/pests/300/420' },
  { id: 6, name: 'Seasonal Guide', rate: '₹399', cover: 'https://picsum.photos/seed/season/300/420' }
];

const BookStore = ({ language = 'en', onAddToCart = () => {}, onPreorder = () => {}, onOpenBook = () => {} }) => {
  const [remoteBooks, setRemoteBooks] = useState([]);
  useEffect(() => {
    let ignore = false;
    (async () => {
      try {
        const resp = await apiGet('/api/books', { locale: language });
        const arr = Array.isArray(resp) ? resp : [];
        if (!ignore) setRemoteBooks(arr.filter((b) => b && b.name));
      } catch (_) {}
    })();
    return () => { ignore = true; };
  }, [language]);

  const list = remoteBooks.length ? remoteBooks : books;

  const short = (s) => {
    if (!s) return '';
    const t = String(s);
    return t.length > 140 ? t.slice(0, 140) + '…' : t;
  };

  return (
    <section id="book-store" className="section bookstore">
      <div className="container">
        <h2 className="bookstore-heading">Book Store</h2>
        <div className="book-grid">
          {list.map((b) => {
            const status = b.status || (b.isPreorder ? 'PREBOOK' : 'INSTOCK');
            const stock = Number(b.stock || 0);
            const isSoldOut = status === 'SOLD_OUT' || (status === 'INSTOCK' && stock <= 0);
            const showPrebook = status === 'PREBOOK';
            const showInStock = status === 'INSTOCK' && stock > 0;
            return (
              <div key={b.id} className="book-item">
                <div className="book-card card" onClick={() => onOpenBook(b)} style={{ cursor: 'pointer', position: 'relative' }}>
                  <img src={b.coverUrl || b.cover} alt={b.name} onError={(e) => { e.currentTarget.src = 'https://via.placeholder.com/300x420/2d5016/ffffff?text=Book'; }} />
                  {/* Status badge */}
                  <div style={{ position: 'absolute', top: 8, left: 8, display: 'flex', gap: 6 }}>
                    {showPrebook && <span className="badge" style={{ background: '#f59e0b', color: '#fff', fontSize: 12, padding: '2px 8px', borderRadius: 12 }}>Prebook</span>}
                    {showInStock && <span className="badge" style={{ background: '#10b981', color: '#fff', fontSize: 12, padding: '2px 8px', borderRadius: 12 }}>In Stock{stock ? ` (${stock})` : ''}</span>}
                    {isSoldOut && <span className="badge" style={{ background: '#6b7280', color: '#fff', fontSize: 12, padding: '2px 8px', borderRadius: 12 }}>Sold Out</span>}
                  </div>
                  <div className="book-overlay">
                    <span className="book-name-center">{b.name}</span>
                  </div>
                </div>
                <div className="book-caption" style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span className="book-name" onClick={() => onOpenBook(b)} style={{ cursor: 'pointer' }}>{b.name}</span>
                    <span className="book-rate">{b.price || b.rate}</span>
                  </div>
                  {/* Quality */}
                  {b.quality && <div style={{ fontSize: 12, color: '#374151' }}>{b.quality}</div>}
                  {/* Description */}
                  {b.description && (
                    <div style={{ fontSize: 14, color: '#555' }}>{short(b.description)}</div>
                  )}
                  {/* Actions */}
                  <div style={{ display: 'flex', gap: 8, marginTop: 6 }}>
                    {showPrebook && (
                      <button className="btn" style={{ background: '#f59e0b', color: '#fff' }} onClick={() => onPreorder(b)}>Preorder</button>
                    )}
                    {showInStock && (
                      <button className="btn" style={{ background: '#2d5016', color: '#fff' }} onClick={() => onAddToCart(b)}>Add to Cart</button>
                    )}
                    {isSoldOut && (
                      <button className="btn" disabled>Sold Out</button>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
} 

export default BookStore;
